var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade"}},[_c('header',{staticClass:"contact text-mono"},[_c('prismic-rich-text',{attrs:{"field":_vm.contact}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }